module.exports = __webpack_public_path__ + "static/partner-icon-7554ca9e65c9657c0c7a6fa0c31b58e5.png";